import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PopupRenderedData from "./Popup/PopupRenderedData";
import SaveThumbnailsTabs from "./conflicts/SaveThumbnailsTabs";

const AnnotatorRightSidebar = () => {
  const { open, hoveredThumbnail } = useSelector((state) => state.popoverStore);
  const [anchor, setAnchor] = React.useState(null);

  const baseStyles = {
    width: '20vw',
    height: '90vh',
    overflowY: 'scroll',
  };

  const maxHeight600 = {
    width: '22vw',
  };

  const maxHeight700 = {
    width: '18vw',
  };
  const maxHeight930={
    height: '94vh',
  }

  // Determine which styles to apply based on conditions
  const stylesToApply = Object.assign(
    {},
    baseStyles,
    // window.innerHeight <= 930 && maxHeight930,
    window.innerHeight <= 600 && maxHeight600,
    
  );
  return (
    <div style={stylesToApply} >
      {hoveredThumbnail && (
        <PopupRenderedData
          {...hoveredThumbnail}
          anchor={anchor}
          setAnchor={setAnchor}
        />
      )}
    </div>
  );
};

export default AnnotatorRightSidebar;
